export const ARTICLE_CATEGORIES = ["Vêtements", "Literie et maison", "Retouche"];
